import { render, staticRenderFns } from "./PHome.vue?vue&type=template&id=129f44d4&"
import script from "./PHome.vue?vue&type=script&lang=ts&"
export * from "./PHome.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports